export class ComponentChangeGroup {
    public static changeGroupCommon = 'commonChangeGroup';
    public static polarGroup = 'polarChangeGroup';
    public static stickGroup = 'stickChangeGroup';
}
